import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import channelsReducer from './slices/channels-slice';
import clientsReducer from './slices/clients-slice';
import hubsReducer from './slices/hubs-slice';
import sensorsReducer from './slices/sensors-slice';
import usersReducer from './slices/users-slice';

const store = configureStore({
  reducer: {
    channels: channelsReducer,
    clients: clientsReducer,
    hubs: hubsReducer,
    sensors: sensorsReducer,
    users: usersReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
